import React, { useEffect, useState, useMemo, useCallback } from "react";
import DataTable from "react-data-table-component";
import swal from "sweetalert";
import {
  changeStatus,
  getDeletedHistory,
} from "../../../services/DeletedRecordsService";

function DeletedRecords() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [reqParams, setReqParams] = useState({
    page: currentPage,
    limit: perPage,
    sort_by: "id",
    sort_direction: "DESC",
    keyword: "",
  });

  const [fetch, setFetch] = useState(true);

  const fetchUsers = useCallback(
    (params) => {
      setLoading(true);
      getDeletedHistory(params)
        .then((res) => {
          setData(res?.data?.data);
          setTotalRows(res?.data?.totalRecords);
          setLoading(false);
          setFetch(false);
        })
        .catch((err) => {
          swal("Error", err?.message, "error");
          setLoading(false);
          setFetch(false);
        });
    },
    [setFetch]
  );

  useEffect(() => {
    if (fetch) {
      fetchUsers(reqParams);
    }
  }, [fetch, reqParams]);

  const onChangeStatus = useCallback(
    (id, published) => {
      let text = "";
      if (published === 2) {
        text = "delete";
      } else if (published === 1) {
        text = "undo";
      } else {
        return false;
      }
      swal({
        title: "Are you sure?",
        text: `Are you sure that you want to ` + text + ` this record?`,
        icon: "warning",
        dangerMode: true,
        buttons: true,
      }).then((res) => {
        if (res) {
          changeStatus({ id, published }).then((res) => {
            setFetch(true);
            swal("Deleted!", res.data.message, "success");
          });
        }
      });
    },
    [changeStatus]
  );

  const columns = useMemo(
    () => [
      {
        name: "Id",
        selector: (row) => row.id,
        wrap: true,
        sortable: true,
        sortField: "id",
      },
      {
        name: "Type",
        selector: (row) => row.type,
        wrap: true,
        sortable: true,
        sortField: "type_id",
      },
      {
        name: "Title",
        selector: (row) => row.title,
        wrap: true,
        sortable: true,
        sortField: "title",
      },
      {
        name: "Date",
        selector: (row) => row.action_date,
        wrap: true,
        sortable: true,
        sortField: "action_date",
      },
      {
        name: "Action by",
        selector: (row) => row.action_by,
        sortable: false,
        wrap: true,
        sortField: "action_by",
      },
      {
        name: "Actions",
        button: "true",
        cell: (row) => {
          return (
            <>
              <button
                className="btn btn-sm btn-outline-warning me-2"
                onClick={() => onChangeStatus(row?.id, 1)}
              >
                <i className="fa fa-undo"></i>
              </button>
              <button
                className="btn btn-sm btn-outline-danger"
                onClick={() => onChangeStatus(row?.id, 2)}
              >
                <i className="fa fa-trash"></i>
              </button>
            </>
          );
        },
      },
    ],
    [onChangeStatus]
  );

  const handlePageChange = useCallback(
    (page) => {
      setCurrentPage(page);
      setReqParams({
        ...reqParams,
        page: page,
      });
      setFetch(true);
    },
    [setReqParams, reqParams, setFetch]
  );

  const handlePerRowsChange = useCallback(
    async (newPerPage, page) => {
      setPerPage(newPerPage);
      setReqParams({
        ...reqParams,
        limit: newPerPage,
      });
      setFetch(true);
    },
    [setReqParams, reqParams, setFetch]
  );

  const handleSort = useCallback(
    (column, sortDirection) => {
      if (column?.sortField !== undefined) {
        setReqParams({
          ...reqParams,
          sort_by: column.sortField,
          sort_direction: sortDirection,
        });
        setFetch(true);
      }
    },
    [reqParams, setReqParams, setFetch]
  );

  return (
    <>
      <div className="row">
        <div className="col-xl-12">
          <div className="table-responsive">
            <DataTable
              columns={columns}
              data={data}
              progressPending={loading}
              pagination
              paginationServer
              paginationTotalRows={totalRows}
              paginationDefaultPage={currentPage}
              onChangeRowsPerPage={handlePerRowsChange}
              onChangePage={handlePageChange}
              //selectableRows
              persistTableHead
              //clearSelectedRows={toggleCleared}
              //conditionalRowStyles={rowStyle}
              //   onSelectedRowsChange={({ selectedRows }) => {
              //     //console.log(selectedRows)
              //     setSelectedRows(selectedRows);
              //   }}
              onSort={handleSort}
              sortServer
              fixedHeader={true}
              fixedHeaderScrollHeight={"500px"}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default DeletedRecords;
